import { Moment } from 'moment';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { setEmployeeOrgMessagesDirty } from '../../messages/actions/set-employee-org-messages-dirty';
import { setJobApplicantJobMessagesDirty } from '../../messages/actions/set-job-applicant-job-messages-dirty';

import Contact from '../contact-api-client';

export const sendBulkMessage = (
  contacts: Array<{ contactId: number; context: ContactContextType }>,
  messageBody: string,
  messageType: string,
  hasVCardAttached: boolean,
  subject?: string | null,
  messagesToClear?: {
    jobId?: number;
    orgId?: number;
  },
  sendDateTime?: Moment | null,
  urlMappings?: Record<string, string>,
) =>
  createGenericDispatcher({
    name: 'SEND_BULK_MESSAGE',
    loadFunction: () =>
      Contact.sendBulkText(
        contacts,
        messageBody,
        messageType,
        hasVCardAttached,
        subject,
        sendDateTime,
        urlMappings,
      ),
    args: {
      contacts,
      messageBody,
      messageType,
      hasVCardAttached,
      subject,
      sendDateTime,
      urlMappings,
    },
    onSuccess: (dispatch: Function) => {
      if (messagesToClear) {
        const { orgId, jobId } = messagesToClear;
        if (jobId) {
          dispatch(setJobApplicantJobMessagesDirty(jobId));
        }
        if (orgId) {
          dispatch(setEmployeeOrgMessagesDirty(orgId));
        }
      }
    },
  });
